
export default function MissionSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-5 gap-12 items-center">
          <div className="col-span-3">
            <p className="text-[#2E7D32] text-sm tracking-[0.2em] mb-3 font-medium">
              OUR MISSION
            </p>
            <h2 className="text-4xl font-serif text-gray-900 mb-6 leading-snug">
              Redefining Luxury Through <br />Nature&apos;s Wisdom
            </h2>
            <p className="text-gray-600 text-[15px] leading-relaxed mb-8">
              Our mission is simple yet profound: to create luxury beauty products that honor the 
              earth and empower the people who use them. We believe that what you put on your body 
              should be as pure as what you put in it. That\u2019s why every Daliah Secret product is 
              formulated with 100% natural ingredients, free from parabens, sulfates, and synthetic 
              fragrances.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#E8F5E9] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#2E7D32] text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">Ethically Sourced</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    Direct partnerships with farmers in Morocco, India, and France
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#E8F5E9] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#2E7D32] text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">Zero Waste Goal</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    Recyclable glass bottles and biodegradable packaging materials
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#E8F5E9] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#2E7D32] text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">Small Batch</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    Each batch is hand-crafted to ensure exceptional quality control
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-[#E8F5E9] flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-[#2E7D32] text-lg"></i>
                </div>
                <div>
                  <h4 className="text-sm font-semibold text-gray-900 mb-1">Giving Back</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">
                    5% of profits support women-led farming cooperatives
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-2">
            <div className="rounded-2xl overflow-hidden h-[520px]">
              <img
                src="https://public.readdy.ai/ai/img_res/15880856cc28d7e971f744388e9da72b.jpg"
                alt="Sustainable ingredient sourcing from organic farms"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
